@if ((detections$ | async); as detections) {
  <div class="container"
    >
    @if ((filters$ | async); as filters) {
      @if ((confidenceFilterSlide$ | async); as slide) {
        <label>{{ 'confidence' | transloco }}</label>
        <filter-slider
          [data]="slide"
          (dataChange)="updateConfidence($event)">
        </filter-slider>
      }
      <label>{{ 'labels' | transloco }}</label>
      <ul>
        @for (item of detections | distinctDetectionLabels; track item) {
          <li>
            <mat-checkbox
              color="primary"
              [checked]="isSelected(filters, item, detectionFilterKeysEnum.LABELS)"
              (change)="toggleValue(filters, item, detectionFilterKeysEnum.LABELS); $event.source._inputElement.nativeElement.blur()">
              {{ item | detectionLabel | async}}
            </mat-checkbox>
          </li>
        }
      </ul>
      <label>{{ 'status' | transloco }}</label>
      <ul>
        @for (item of (status$ | async) ?? []; track item.value) {
          <li>
            <mat-checkbox
              color="primary"
              [checked]="isSelected(filters, item.value, detectionFilterKeysEnum.STATUS)"
              (change)="toggleValue(filters, item.value, detectionFilterKeysEnum.STATUS); $event.source._inputElement.nativeElement.blur()">
              {{ item.label }}
            </mat-checkbox>
          </li>
        }
      </ul>
      <label>{{ 'create_modes' | transloco }}</label>
      <ul>
        @for (item of detections | distinctDetectionCreateModes; track item) {
          <li>
            <mat-checkbox
              color="primary"
              [checked]="isSelected(filters, item, detectionFilterKeysEnum.CREATE_MODES)"
              (change)="toggleValue(filters, item, detectionFilterKeysEnum.CREATE_MODES); $event.source._inputElement.nativeElement.blur()">
              {{ item | formatDetectionMode }}
            </mat-checkbox>
          </li>
        }
      </ul>
    }
  </div>
}
